import { Component } from 'react';
import PropTypes from 'prop-types';

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var NotPaid = function (_Component) {
  inherits(NotPaid, _Component);

  function NotPaid() {
    classCallCheck(this, NotPaid);
    return possibleConstructorReturn(this, (NotPaid.__proto__ || Object.getPrototypeOf(NotPaid)).apply(this, arguments));
  }

  createClass(NotPaid, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          dueDateStr = _props.dueDate,
          daysOverdue = _props.daysOverdue;


      var dueDate = new Date(dueDateStr);
      var currentDate = new Date();
      var utc1 = Date.UTC(dueDate.getFullYear(), dueDate.getMonth(), dueDate.getDate());
      var utc2 = Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
      var days = Math.floor((utc2 - utc1) / (1000 * 60 * 60 * 24));

      if (days > 0) {
        var daysLate = daysOverdue - days;
        var opacity = daysLate * 100 / daysOverdue / 100;
        opacity = opacity < 0 ? 0 : opacity;
        opacity = opacity > 1 ? 1 : opacity;

        if (opacity >= 0 && opacity <= 1) {
          document.getElementsByTagName("BODY")[0].style.opacity = opacity;
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return NotPaid;
}(Component);

NotPaid.defaultProps = {
  daysOverdue: 60
};
NotPaid.propTypes = {
  dueDate: PropTypes.string.isRequired,
  daysOverdue: PropTypes.number
};

export default NotPaid;
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 18
// module chunks = 0